import request from '@wearetla/tla-essentials-tools/utilities/request';

// Functions
import formatDate from '@wearetla/tla-essentials-tools/functions/format-date';

const userServices = {
	getUserData: () => {
		return new Promise((resolve, reject) => {
			request.get(`user/me`, {}, (payload, status, request) => {
				if (status === 200 && payload?.user) {
					resolve({
						...payload.user,
						birthdate: payload.user.birthdate
							? payload.user.birthdate.split('-').reverse().join('/')
							: '',
						required_agreements: payload.required_agreements ?? [],
					});
				} else {
					reject(
						request?.data?.meta?.messages ||
							'Kullanıcı bilgileri getirilirken bir hata ile karşılaşıldı.'
					);
				}
			});
		});
	},
	getGuestToken: () => {
		return new Promise((resolve, reject) => {
			request.get(`users/init`, {}, (payload, status, request) => {
				if (payload?.guest_token) {
					resolve(payload.guest_token);
				} else {
					reject(
						request?.data?.meta?.messages ||
							'Kullanıcı bilgisi getirilirken bir hata ile karşılaşıldı.'
					);
				}
			});
		});
	},
	logout: () => {
		return new Promise((resolve, reject) => {
			request.delete(`users/logout`, {}, (payload, status, request) => {
				if (status === 200) {
					resolve();
				} else {
					reject(request?.data?.meta?.messages || 'Çıkış yapılırken bir hata ile karşılaşıldı.');
				}
			});
		});
	},
	// User Info
	updateInfo: (userData) => {
		return new Promise((resolve, reject) => {
			request.post(`user/update`, { ...userData }, (payload, status, request) => {
				if (status === 200) {
					resolve(
						request?.data?.meta?.messages || {
							success: 'Üyelik bilgileriniz başarıyla güncellendi.',
						}
					);
				} else {
					reject(
						request?.data?.meta?.messages ||
							'Üyelik bilgileriniz güncellenirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
					);
				}
			});
		});
	},
	deleteUser: (token) => {
		return new Promise((resolve, reject) => {
			request.post(`user/delete`, { otp_token: token }, (payload, status, request) => {
				if (status === 200) {
					resolve(
						request?.data?.meta?.messages || {
							success: 'Silme talebinizi aldık. 15 gün içinde hesabınız silinecek.',
						}
					);
				} else {
					reject(
						request?.data?.meta?.messages ||
							'Silme talebiniz alınırken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
					);
				}
			});
		});
	},
	deleteUserRequest: (formFields) => {
		return new Promise((resolve, reject) => {
			request.post(`privacy/data-delete-apply`, { ...formFields }, (payload, status, request) => {
				if (status === 200) {
					resolve(
						request?.data?.meta?.messages || {
							success: 'Silme talebinizi aldık. 15 gün içinde talebinizi işleme alacağız.',
						}
					);
				} else {
					reject(
						request?.data?.meta?.messages ||
							'Silme talebiniz alınır bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
					);
				}
			});
		});
	},
	// Agreements
	getAgreement: (key, parameter) => {
		return new Promise((resolve, reject) => {
			request.get(
				`agreement/${key}${parameter ? `/${parameter}` : ''}`,
				false,
				function (payload, status, request) {
					if (status === 200 && payload?.agreement) {
						resolve(payload.agreement);
					} else {
						reject(
							request?.data?.meta?.messages ||
								'Sözleşme getirilirken bir hata ile karşılaşıldı, lütfen daha sonra tekrar deneyin.'
						);
					}
				},
				{}
			);
		});
	},
	getAllAgreements: () => {
		return new Promise((resolve, reject) => {
			request.get(
				`agreement/all`,
				false,
				function (payload, status, request) {
					if (status === 200 && payload?.agreements) {
						resolve(payload.agreements);
					} else {
						reject(
							request?.data?.meta?.messages ||
								'Sözleşmeler getirilirken bir hata ile karşılaşıldı, lütfen daha sonra tekrar deneyin.'
						);
					}
				},
				{}
			);
		});
	},
	updateAgreements: (agreements) => {
		return new Promise((resolve, reject) => {
			request.post(
				`user/agreement/update`,
				{ agreements },
				function (payload, status, request) {
					if (status === 200) {
						resolve(payload);
					} else {
						reject(
							request?.data?.meta?.messages ||
								'Sözleşmeler onaylanırken bir hata ile karşılaşıldı, lütfen daha sonra tekrar deneyin.'
						);
					}
				},
				{}
			);
		});
	},
	// Notifications
	getNotificationCount: () => {
		return new Promise((resolve, reject) => {
			request.get(`user/notifications/count`, {}, (payload, status, request) => {
				if (status === 200 && payload?.notification_count) {
					resolve(payload.notification_count);
				} else {
					reject(
						request?.data?.meta?.messages || 'Güncelleme yapılırken bir hata ile karşılaşıldı.'
					);
				}
			});
		});
	},
	readAllNotifications: () => {
		return new Promise((resolve, reject) => {
			request.get(`user/notifications/read-all`, {}, (payload, status, request) => {
				if (status === 200) {
					resolve(true);
				} else {
					reject(
						request?.data?.meta?.messages || 'Güncelleme yapılırken bir hata ile karşılaşıldı.'
					);
				}
			});
		});
	},
	getNotifications: () => {
		return new Promise((resolve, reject) => {
			request.get(`user/notifications`, {}, (payload, status, request) => {
				if (status === 200 && payload?.notifications) {
					resolve(
						payload.notifications.map((notification) => ({
							...notification,
							formatted_created_at: formatDate(notification.created_at, 'd MMMM yyyy, HH:mm'),
						}))
					);
				} else {
					reject(
						request?.data?.meta?.messages || 'Bildirimler getirilirken bir hata ile karşılaşıldı.'
					);
				}
			});
		});
	},
	// OTP
	sendOTP: (phoneNumber, action = 'login') => {
		return new Promise((resolve, reject) => {
			request.post(
				`otp/send`,
				{
					phone: phoneNumber,
					token_type: `${action}_token`,
				},
				(payload, status, request) => {
					if (status === 200) {
						resolve(true);
					} else {
						reject(
							request?.data?.meta?.messages ||
								'SMS gönderilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
						);
					}
				}
			);
		});
	},
	checkOTP: (phoneNumber, code) => {
		return new Promise((resolve, reject) => {
			request.post(
				`otp/verify`,
				{
					phone: phoneNumber,
					otp_code: code,
				},
				(payload, status, request) => {
					if (status === 200 && payload?.otp_token) {
						resolve(payload.otp_token);
					} else {
						reject(
							request?.data?.meta?.messages ||
								'SMS onaylanırken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
						);
					}
				}
			);
		});
	},
	login: (phoneNumber, otpToken) => {
		return new Promise((resolve, reject) => {
			request.post(
				'auth/login',
				{
					phone: phoneNumber,
					otp_token: otpToken,
				},
				(payload, status, request) => {
					if (status === 200 && payload?.access_token) {
						resolve(payload);
					} else {
						reject(
							request?.data?.meta?.messages ||
								'Giriş işlemi gerçekleştirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
						);
					}
				}
			);
		});
	},
	register: (registerData) => {
		return new Promise((resolve, reject) => {
			request.post(
				'auth/register',
				{
					...registerData,
				},
				(payload, status, request) => {
					if (status === 200 && payload?.access_token) {
						resolve(payload);
					} else {
						reject(
							request?.data?.meta?.messages ||
								'Üye kayıt işlemi gerçekleştirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
						);
					}
				}
			);
		});
	},
};

export default userServices;
